module.exports = __webpack_public_path__ + "static/media/assessmentViewPage.6663000f.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assessments/assessmentViewPage.scss
// module id = 527
// module chunks = 0